import {useEffect, useState} from "react";
import {Select, Space, DatePicker, InputNumber} from 'antd';
import {UsePut} from "../../../hooks/http";
import dayjs from "dayjs";


const Campaign = (props) => {
    const {setValue} = props;


    const [channel, setChannel] = useState("")
    const [campaign, setCampaign] = useState("")
    const [campaigns, setCampaigns] = useState([])
    const [isLoading, setIsLoading] = useState(true)


    const onChange = (value) => {
        if (campaign !== value) {
            setValue(value);
        }
    };


    const getCampaigns = async (channel) => {
        const output = []
        const request = await UsePut(
            `/${channel}/get`,
            {data: {limit: 0, offset: 0}},
        )

        if (request?.entities?.length > 0) {
            request.entities.map(entity => {
                output.push({
                    value: entity._id.$oid,
                    label: channel === 'emails' ? entity.content.subject : channel === 'landings' ? entity.name : entity.title
                })
            })
        }

        return output
    }


    const handleChannel = (value) => {

        setIsLoading(true)
        setChannel(value)

        getCampaigns(value).then(response => {
            setCampaigns(response)
            setIsLoading(false)
        })
    };


    return (
        <Space wrap>
            <Select
                size="small"
                placeholder="Channel"
                style={{width: 100,}}
                onChange={handleChannel}
                options={[
                    {value: 'sms', label: 'Sms'},
                    {value: 'emails', label: 'Email'},
                    {value: 'landings', label: 'Landing'},
                ]}
            />
            {channel && channel !== "" && <Select
                size="small"
                loading={isLoading}
                style={{width: 210,}}
                onChange={onChange}
                defaultValue={campaign}
                placeholder="Campaign"
                options={campaigns}
            />}

        </Space>
    );
};


const Scope = (props) => {
    const {value, setValue, field, operator} = props;

    const [channel, setChannel] = useState("")
    const [campaign, setCampaign] = useState("")
    const [campaigns, setCampaigns] = useState([])
    const [isLoading, setIsLoading] = useState(true)


    const onChange = (value) => {
        if (campaign !== value) {
            setValue(value);
        }
    };


    const getConsentTypes = async () => {
        const output = {
            values : [],
            hasMore: false,
        }


        /*const request = await UsePut(
            `/audiences/${audience?._id?.$oid}/consents/types/get`,
            {data: {limit: 0, offset: 0}, toArray: true, propLabel: 'name', keyLabel: 'slug'},
        );

        if (request?.length > 0) {
            request.map(type => {
                output.values.push({title: type.name, value: type.slug})
            })
        }*/

        return output
    }

    const getCampaigns = async (channel) => {
        const output = []
        const request = await UsePut(
            `/${channel}/get`,
            {data: {limit: 0, offset: 0}},
        )

        if (request?.entities?.length > 0) {
            request.entities.map(entity => {
                output.push({
                    value: entity._id.$oid,
                    label: channel === 'emails' ? entity.content.subject : channel === 'landings' ? entity.name : entity.title
                })
            })
        }

        return output
    }


    const handleChannel = (value) => {

        setIsLoading(true)
        setChannel(value)

        getCampaigns(value).then(response => {
            setCampaigns(response)
            setIsLoading(false)
        })
    };


    return (
        <Space wrap>
            <Select
                name="scope"
                size="small"
                placeholder="Channel"
                style={{width: 100,}}
                onChange={handleChannel}
                options={[
                    {value: 'sms', label: 'Sms'},
                    {value: 'emails', label: 'Email'},
                    {value: 'landings', label: 'Landing'},
                ]}
            />
            {channel && channel !== "" && <Select
                size="small"
                loading={isLoading}
                style={{width: 210,}}
                onChange={onChange}
                defaultValue={campaign}
                placeholder="Campaign"
                options={campaigns}
            />}

        </Space>
    );
};

const dayJsFormat = 'YYYY-MM-DD HH:mm'

const frequencies = [
    {value: 'hours', label: 'Hours'},
    {value: 'days', label: 'Days'},
    {value: 'hours_range', label: 'Hours Range'},
    {value: 'days_range', label: 'Days Range'},
]

const countDownStyles = {
    display   : "flex",
    gap       : '10px',
    alignItems: "center",
    minWidth  : 350
}

const CustomDatetime = (props) => {

    const {value, setValue, operator} = props;
    const [units, setUnits] = useState(value?.units || null)
    const [date, setDate] = useState(value?.dateString || null)
    const [frequency, setFrequency] = useState(value?.frequency || frequencies[0].value);
    const [countdown, setCountdown] = useState(value?.countdown || false)


    const filteredFrequencies = operator === 'equal' || operator === 'not_equal'
        ? frequencies
        : frequencies.filter(f => f.value !== 'hours_range' && f.value !== 'days_range');


    useEffect(() => {
        setValue({
            units     : units,
            dateString: date,
            countdown : countdown,
            frequency : frequency,
        });
    }, [date, units, countdown, frequency]);


    useEffect(() => {
        if (!filteredFrequencies.find(f => f.value === frequency)) {
            setFrequency(filteredFrequencies[0]?.value);
        }
    }, [operator, filteredFrequencies]);


    return (

        <div style={operator !== 'between' ? countDownStyles : {}}>
            {operator !== 'between' && <label style={{marginTop: '3px', cursor: 'pointer'}}>
                <input
                    type="checkbox"
                    checked={countdown}
                    onChange={ev => {
                        setCountdown(ev.target.checked)
                        if (!ev.target.checked){
                            setUnits(null)
                            setFrequency(null)
                        }
                        if (ev.target.checked) setDate(null)
                    }}
                    style={{
                        marginRight: '7px',
                        position   : 'relative',
                        top        : '2px'
                    }}
                />
                Countdown
            </label>}


            {(!countdown || operator === 'between') &&
                <DatePicker
                    showTime
                    size="small"
                    placeholder={date}
                    format={dayJsFormat}
                    value={date?.length > 0 ? dayjs(date, dayJsFormat) : ''}
                    onChange={(date, dateString) => {
                        setDate(dateString)
                        setUnits(null)
                        setFrequency(null)
                        setCountdown(false)
                    }}
                />
            }

            {(countdown && operator !== 'between') &&
                <>
                    <InputNumber
                        min={1}
                        size="small"
                        value={units}
                        onChange={ev => setUnits(ev)}
                        style={{width: '60px'}}
                        placeholder={frequency ? `${frequency.split('_')[0]}` : 'hours'}
                    />

                    <Select
                        size="small"
                        options={filteredFrequencies}
                        style={{width: '140px', textAlign: 'left'}}
                        value={frequency || filteredFrequencies[0].value}
                        onChange={(ev, opt) => setFrequency(ev)}
                    />
                </>

            }
        </div>
    );
};


export {Campaign, Scope, CustomDatetime}